import { User, Invitation, AuthenticationType } from '@portal-front-end/models';
import { RequestInfo, InMemoryDbService, RequestInfoUtilities, ParsedRequestUrl } from 'angular-in-memory-web-api';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import roleValues from '../../../../../apps/portal-front-end/src/app/roles-permissions-store/roles';

@Injectable({
    providedIn: 'root'
})
export class PortalFrontendMockBackend implements InMemoryDbService {
    dummyDate = new Date();
    createDb(reqInfo?: RequestInfo): {} | Observable<{}> | Promise<{}> {
        return {
            userses: [
                {
                    userId: '1',
                    email: 'test@mail.com',
                    firstName: 'John',
                    lastName: 'Doe',
                    roleId: 1,
                    invitationId: 'invitation-id-1',
                    deleted: false
                },
                {
                    userId: '2',
                    email: 'sample@mail.com',
                    firstName: 'Juan',
                    lastName: 'Dela Cruz',
                    roleId: 1,
                    invitationId: 'invitation-id-2',
                    deleted: false
                },
            ] as User[],
            invitations: [
                {
                    invitationId: `3fa85f64-5717-4562-b3fc-2c963f66afa6`,
                    senderUserId: `3fa85f64-5717-4562-b3fc-2c963f66afa6`,
                    email: 'invite@mail.com',
                    roleId: 0,
                    createdAt: this.dummyDate,
                    expiresAt: this.dummyDate,
                    acceptedAt: this.dummyDate,
                    invitationUrl: 'invitation.com'
                },
                {
                    invitationId: `3fa85f64-5717-4562-b3fc-2c963f66afg6`,
                    senderUserId: `3fa85f64-5717-4562-b3fc-2c963f66afa6`,
                    email: 'another_invite@mail.com',
                    roleId: 0,
                    createdAt: this.dummyDate,
                    expiresAt: this.dummyDate,
                    acceptedAt: this.dummyDate,
                    invitationUrl: 'invitation.com'
                }
            ] as Invitation[],
            authentications: {
                access_token: 'string',
                token_type: 'string',
                refresh_token: 'string',
                expires_in: 100,
                scope: 'string',
                user_id: '1',
                oauth_client_details_id: 100,
            } as AuthenticationType,
            authusers: {
                userId: '40132fe9-ff5d-ba9a-bfc6-ab632083ad97',
                deleted: false,
                email: 'alex@abcis.com.au',
                firstName: 'Alex',
                lastName: 'Selles',
                organisations: [
                    {
                        organisation: {
                            organisationId: '11ea93f6-5681-9edd-a733-00155d77010c',
                            shortCode: 'abcis1',
                            organisationTypeId: 1,
                            organisationName: 'ABCIS',
                            statusId: 1
                        },
                        roleId: 3,
                    }
                ]
            },
            permissions: roleValues
        };
    }
}

